module.exports = __webpack_public_path__ + "static/media/proj1_img13.25d86eed.jpg";